import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useColorScheme } from '@/composables/ui/useColorScheme'

// Initialize color scheme (dark mode)

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useColorScheme()

// Note: Page title is now managed by router.afterEach() in router/index.ts
// This ensures the title updates dynamically based on the current route

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})